// Configuration
const tests = {
  'T003-TEST': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [
          { pathnames: ['/products/balance-bike', '/products/14-inch-bike', '/products/16-inch-bike', '/products/20-inch-small-bike', '/products/20-inch-large-bike', '/products/24-inch-bike', '/products/26-inch-bike'], key: "_gbab", value: "T001-A" }
        ],
        selectors: [
        ]
      },
      'B': {
        productProperties: [
          { pathnames: ['/products/balance-bike', '/products/14-inch-bike', '/products/16-inch-bike', '/products/20-inch-small-bike', '/products/20-inch-large-bike', '/products/24-inch-bike', '/products/26-inch-bike'], key: "_gbab", value: "T001-B" }
        ],
        selectors: [
          // {element: '.product-template[data-product-id=\"4837430001757\"] .as-low-as-discounted-price', type: 'price', discount: 1000},
          // {element: '.product-template[data-product-id=\"4837426954333\"] .as-low-as-discounted-price', type: 'price', discount: 1000},
          // {element: '.product-template[data-product-id=\"4837430394973\"] .as-low-as-discounted-price', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837430001757\"] .as-low-as-discounted-price', type: 'innerText', value: '$289'},
          {element: '.product-template[data-product-id=\"4837426954333\"] .as-low-as-discounted-price', type: 'innerText', value: '$319'},
          {element: '.product-template[data-product-id=\"4837430394973\"] .as-low-as-discounted-price', type: 'innerText', value: '$339'},
          {element: '.product-template[data-product-id=\"4837430001757\"] .ProductPrice-product-new-layout-combined', type: 'innerText', value: '$289.00' },
          {element: '.product-template[data-product-id=\"4837426954333\"] .ProductPrice-product-new-layout-combined', type: 'innerText', value: '$319.00' },
          {element: '.product-template[data-product-id=\"4837430394973\"] .ProductPrice-product-new-layout-combined', type: 'innerText', value: '$339.00' },
          {element: '.product-template[data-product-id=\"4837430001757\"] [data-pro-price]', type: 'dataset', dataset: 'proPrice', value: '$289.00' },
          {element: '.product-template[data-product-id=\"4837426954333\"] [data-pro-price]', type: 'dataset', dataset: 'proPrice', value: '$319.00' },
          {element: '.product-template[data-product-id=\"4837430394973\"] [data-pro-price]', type: 'dataset', dataset: 'proPrice', value: '$339.00' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-small-bike"] .collection_with_options-price', type: 'innerText', value: '$289' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-large-bike"] .collection_with_options-price', type: 'innerText', value: '$319' },
          {element: '.collection_with_options-grid-item[data-product="24-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$339' }          
        ]
      }
    }
  },
  'T002': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [],
        selectors: []
      },
      'B': {
        productProperties: [],
        selectors: [
          {element: '.how-surestop-works-link .video-underline', type: 'innerText', value: 'LEARN TO RIDE IN 1 DAY™'},
        ]
      }
    }
  },
  'T004-EmptyTest': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [],
        selectors: []
      },
      'B': {
        productProperties: [],
        selectors: []
      }
    }
  },
  'T005-Sale-Messaging': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [],
        selectors: [
          {
            type: 'visibility',
            hide: '.hero-image-v3--content--B',
            show: '.hero-image-v3--content--A'
          }
        ]
      },
      'B': {
        productProperties: [],
        selectors: [
          {
            type: 'visibility',
            hide: '.hero-image-v3--content--A',
            show: '.hero-image-v3--content--B'
          }
        ]
      }
    }
  }
};

function addCSSRule(selector, rules) {
  // Create a style element if it doesn't exist
  if (!window.dynamicStyles) {
    window.dynamicStyles = document.createElement('style');
    window.dynamicStyles.type = 'text/css';
    document.head.appendChild(window.dynamicStyles);
  }

  // Append the new rule
  const sheet = window.dynamicStyles.sheet;
  const ruleIndex = sheet.cssRules.length;
  sheet.insertRule(`${selector} { ${rules} }`, ruleIndex);
}
function abSetCookie (name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function abGetCookie (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie (name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}



function abSetLocalStorage(name, value, days) {
  const item = {
    value: value,
    expiry: days ? new Date().getTime() + (days * 24 * 60 * 60 * 1000) : null
  };
  localStorage.setItem(name, JSON.stringify(item));
}

function abGetLocalStorage(name) {
  const itemStr = localStorage.getItem(name);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  if (item.expiry && new Date().getTime() > item.expiry) {
    localStorage.removeItem(name);
    return null;
  }
  return item.value;
}

function eraseLocalStorage(name) {
  localStorage.removeItem(name);
}





function abAddProductProperty(key, value) {
  let keySlug = key.replaceAll(' ', '_')
  var input = $('<input id="preorded-property-'+keySlug+'" type="hidden" name="properties['+key+']" value="'+value+'" />')[0]
  $("#AddToCartForm").append(input)
}
// Function to randomly select a variant
function selectRandomVariant(test) {
  const variants = Object.keys(test.variants);
  return variants[Math.floor(Math.random() * variants.length)];
}
  
function gbFormatPrice (cents) {
  if (cents%100 == 0) {
    return "$"+(cents/100)
  } else {
    return (cents/100).toLocaleString("en-US", {style:"currency", currency:"USD"})
  }
}

function gbGetQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  var paramValue = urlParams.get(param);
  return paramValue;
}

// Function to apply the variant
function applyVariant(testName, variant, applyProperties) {
  console.log("***** testName", testName)
  console.log("***** variant", variant)
  const testVariant = tests[testName]['variants'][variant];
  
  let testVariantSelectors = testVariant.selectors

  testVariant.selectors.forEach(selector => {
    console.log("***** selector", selector)
    console.log("***** selector.type", selector.type)
    console.log("***** selector.type === 'visibility'", selector.type === 'visibility')
    console.log("***** selector.hide", selector.hide)
    console.log("***** selector.element", selector.element)

      if (selector.type === 'visibility') {
        console.log("****** selector.type === 'visibility'")
        // New visibility type that hides one selector and shows another
        if (selector.hide) {
          const hideElements = document.querySelectorAll(selector.hide);
          console.log("***** hideElements", hideElements)
          hideElements.forEach(el => {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
          });
        }
        if (selector.show) {
          const showElements = document.querySelectorAll(selector.show);
          console.log("***** showElements", showElements)
          showElements.forEach(el => {
            el.style.display = 'flex';
            el.style.visibility = 'visible';
          });
        }
      } else {
        const testVariantSelectorElements = document.querySelectorAll(selector.element);
        testVariantSelectorElements.forEach(element => {
          if (selector.type === 'innerText') {
            element.innerText = selector.value
          } else if (selector.type === 'price') {
            let currentPrice = element.dataset.gbPrice
            let newPrice = currentPrice - selector.discount
            element.innerText = gbFormatPrice(newPrice)
          } else if (selector.type === 'dataset') {
            element.dataset[selector.dataset] = selector.value
          }
          // Only set visibility for non-visibility type selectors
          if (selector.type !== 'visibility') {
            element.style.visibility = 'visible'
          }
        })
      }


  })

  if (applyProperties) {
    let testVariantProductProperties = testVariant.productProperties
    for (let i=0;i<testVariantProductProperties.length;i++) {
      const testVariantProductProperty = testVariantProductProperties[i]
      if (testVariantProductProperty.pathnames.includes(window.location.pathname)) {
        abAddProductProperty(testVariantProductProperty.key, testVariantProductProperty.value)
      }
    }
  }

  
}



// Run all tests
function runTests(variant) {

  
  for (let testName in tests) {
    let test = tests[testName]
    if (!test.enabled) {
      // console.log("Test", testName, "not enabled")
      continue;
    }
    // let variant = abGetCookie(`gbab_${testName}`)
    if (!variant) {
      variant = selectRandomVariant(test);
      // abSetCookie(`gbab_${testName}`, variant)
    }
    applyVariant(testName, variant, true);
  }
}


function getUtmParamsFromShopifyCookie() {
  // Get the _shopify_sa_p cookie
  const shopifySaP = abGetCookie('_shopify_sa_p');
  
  if (!shopifySaP) {
    console.log('_shopify_sa_p cookie not found');
    return null;
  }
  
  try {
    // The cookie value is URL encoded
    const decodedCookie = decodeURIComponent(shopifySaP);
    
    // Create a URLSearchParams object with the decoded cookie
    // We need to prefix with a dummy URL if it's just a query string
    const queryString = decodedCookie.includes('?') ? decodedCookie : '?' + decodedCookie;
    const searchParams = new URLSearchParams(queryString);
    
    // Extract UTM parameters
    const utmParams = {
      utm_source: searchParams.get('utm_source') || null,
      utm_medium: searchParams.get('utm_medium') || null,
      utm_campaign: searchParams.get('utm_campaign') || null,
      utm_content: searchParams.get('utm_content') || null,
      utm_term: searchParams.get('utm_term') || null
    };
    
    console.log('UTM parameters extracted from _shopify_sa_p cookie:', utmParams);
    return utmParams;
    
  } catch (error) {
    console.error('Error parsing _shopify_sa_p cookie:', error);
    return null;
  }
}

function setABTestGroup(testName,  variant){
  // console.log("SETTING AB TEST GROUP", testName,  variant)
  // snowplow("trackStructEvent", {
  //   category: "GBAB",
  //   action: testName,
  //   label: variant
  // });

  abSetLocalStorage(`gbab_${testName}`, variant)
  
  const shopifyUserId = abGetCookie('_shopify_y');
  const sessionId = abGetCookie('_shopify_s');
  const utmParams = getUtmParamsFromShopifyCookie();

  if (shopifyUserId && sessionId) {
    // Send data to the API endpoint
    fetch('https://ab.guardianbikes.com/api/participant', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-gbab': 'A2K%rTtJWgY*HcYXY5Wc^4jBZpErzEEp'
      },
      body: JSON.stringify({
        shopifyUserId: shopifyUserId,
        sessionId: sessionId,
        name: testName,
        variant: variant,
        utmSource: utmParams?.utm_source || null,
        utmMedium: utmParams?.utm_medium || null,
        utmCampaign: utmParams?.utm_campaign || null,
        utmContent: utmParams?.utm_content || null,
        utmTerm: utmParams?.utm_term || null
      })
    })
    .then(response => {
      if (!response.ok) {
        console.error('Error recording A/B test participant:', response.statusText);
        return;
      }
      return response.json();
    })
    .then(data => {
      if (data) {
        console.log('A/B test participant recorded:', data);
      }
    })
    .catch(error => {
      console.error('Failed to record A/B test participant:', error);
    });
  } else {
    console.warn('Missing shopify_user_id or session_id for A/B test tracking');
  }
  
}


function hideABTestCSS() {
  for (let testName in tests) {
    let test = tests[testName]
    if (!test.enabled) {
      continue;
    }
    let variant = abGetLocalStorage(`gbab_${testName}`)
    if (!variant) {
      variant = selectRandomVariant(test);
      console.log("Assigned to variant", variant)
      setABTestGroup(testName, variant)
    } else {
      console.log("Loaded variant")
    }
    const testVariant = tests[testName]['variants'][variant];
    testVariant.selectors.forEach(selector => {
      if (selector.type === 'visibility') {
        // For visibility type, initially hide both elements to prevent flash
        if (selector.hide) {
          addCSSRule(selector.hide, "display: none !important;")
        }
        if (selector.show) {
          // Initially hide the "show" element too to prevent flash
          // The applyVariant function will show it later
          addCSSRule(selector.show, "visibility: hidden;")
        }
      } else if (selector.element) {
        // Only add visibility hidden for selectors that have an element property
        addCSSRule(selector.element, "visibility: hidden;")
      }
    })
    return variant
  }
}

function hideControlCSS() {
  for (let testName in tests) {
    let test = tests[testName]
    const testVariant = tests[testName]['variants']["A"];
    testVariant.selectors.forEach(selector => {
      addCSSRule(selector.element, "visibility: hidden;")
    })
  }
}


function applyExcludedControl() {
  for (let testName in tests) {
    // console.log("["+testName+"] In excluded control")
    applyVariant(testName, "A", false);
  }
}


function changeCartABProperties(variant) {

    fetch('/cart?view=alternate.json')
      .then(response => response.json())
      .then(data => {
        if (data.error === true) {
          console.log("error", data.error);
        } else {
          const bikesInCart = data.items.filter(item => item.product_type === "Kids Bikes");
    
          bikesInCart.forEach(bike => {
            const bikeProperties = bike.properties;
            if (bikeProperties["_gbab"] === "T001-"+variant) {
              return;
            }
            bikeProperties["_gbab"] = "T001-"+variant;
    
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: bike.key,
                properties: bikeProperties
              })
            })
            .then(response => response.json())
            .then(cart => {
              console.log("Updated cart");
              // if (typeof ajaxCart !== 'undefined' && ajaxCart !== null) {
              //   ajaxCart.load();
              // }
            })
            .catch(error => {
              console.log('Error:', error);
            });
          });
        }
      })
      .catch(error => {
        console.log('Error:', error);
      });
}


let skipGoogle = false
let googleExclusion = abGetLocalStorage('google_exclusion')
let utmSource = gbGetQueryParam('utm_source');
let utmMedium = gbGetQueryParam('utm_medium');
let utmCampaign = gbGetQueryParam('utm_campaign');

if (skipGoogle && ((utmSource && utmMedium && utmCampaign) || googleExclusion == 1)) {
  console.log("skipping.")
  let utmSourceLower = utmSource && utmSource.toLowerCase()
  let utmMediumLower = utmMedium && utmMedium.toLowerCase()
  let utmCampaignLower = utmCampaign && utmCampaign.toLowerCase()
  let campaignContainsShopOrPmax = utmCampaign && ['p.max', 'shopping'].some(function(value) {
    return utmCampaignLower.indexOf(value) !== -1;
  });
  

  if (googleExclusion == 1 || (utmSourceLower == 'google' && utmMediumLower == 'cpc' && campaignContainsShopOrPmax)) {
    hideControlCSS()

    if (!googleExclusion) {
      // Record exclusion for each enabled test
      for (let testName in tests) {
        let test = tests[testName]
        if (test.enabled) {
          setABTestGroup(testName, "Excluded")
        }
      }
    }

    
    abSetLocalStorage(`google_exclusion`, 1)
    
    // Run tests as soon as the DOM is ready
    if (document.readyState !== 'loading') {
      applyExcludedControl()
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        applyExcludedControl()
      });
    }
  }
  
} else {
  console.log("*****")
  let variant = hideABTestCSS()
  console.log('***** variant', variant)
  // Run tests as soon as the DOM is ready
  if (document.readyState !== 'loading') {
    runTests(variant);
    // if (variant == "B") {
    //   changeCartABProperties(variant)
    // }
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      runTests(variant)
      // if (variant == "B") {
      //   changeCartABProperties(variant)
      // }
    });
  }
}



